
export default {
  name: 'BaseDocumentLink',

  props: {
    link: {
      type: Object,
      required: true,
    },
  },

  computed: {
    extension () {
      return this.link.fullpath.split('.').pop()
    },

    documentDescription () {
      return this.link.productLabel || this.link.filename
    },
  },
}
